<script>
	// Stores 
	import { 
		linkMapa, 
		linkWaze, 
		linkUber, 
		mailAtendimento, 
		mailLocacao, 
		mailVendas, 
		mailCondominios, 
		mailOuvidoria, 
		textSite, 
		textEndereco, 
		textWhatsapp, 
		textTelefone, 
		linkTelefone, 
		textAtendimento,
		linkWhatsapp,
		textWhatsappCondominio,
		linkWhatsappCondominio,
		textWhatsappLocacao,
		linkWhatsappLocacao,
		textWhatsappVendas,
		linkWhatsappVendas,
		textWhatsappRH,
		linkWhatsappRH
	} from '../store.js';    

	// Componentes
	import { link } from "svelte-routing";

	import Forms from "../components/Forms.svelte";  
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Contato ';

	let mensagem = GetHash('assunto') == null ? '' : GetHash('assunto');

	let contatos = [
		{   
			name: 'Atendimento',
			link: $linkTelefone,
			text: $textTelefone,
			icon: '<i class="fas color-primary fa-phone"></i>'
		},
		{   
			name: 'Whatsapp',
			link: $linkWhatsapp,
			text: $textWhatsapp,
			icon: '<i class="fab color-primary fa-whatsapp"></i>'
		},
		{   
			name: 'WhatsappCondominio',
			link: $linkWhatsappCondominio,
			text: $textWhatsappCondominio,
			icon: '<i class="fab color-primary fa-whatsapp"></i>'
		},
		{   
			name: 'WhatsappLocacao',
			link: $linkWhatsappLocacao,
			text: $textWhatsappLocacao,
			icon: '<i class="fab color-primary fa-whatsapp"></i>'
		},
		{   
			name: 'WhatsappVendas',
			link: $linkWhatsappVendas,
			text: $textWhatsappVendas,
			icon: '<i class="fab color-primary fa-whatsapp"></i>'
		},
		{   
			name: 'WhatsappRH',
			link: $linkWhatsappRH,
			text: $textWhatsappRH,
			icon: '<i class="fab color-primary fa-whatsapp"></i>'
		}
	];    

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fas fa-map-marked-alt color-primary"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fab fa-waze color-primary"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fab fa-uber color-primary"></i>',
			link: $linkUber,
		}
	];    

	let fields = [
		{
			title:  'Nome *',
			name:   'nome',
			required:   'required'
		},
		{
			title:  'Telefone *',
			name:   'telefone',
			required: 'required',
			classe: 'mask-telefone',
		},
		{
			title:  'Email *',
			name:   'email',
			type:   'email',
			required: 'required',
		},
		{
			title:  'Destino',
			name:   'destino',
			type:   'select',
			selectValues: [
				{
					title: 'Atendimento Geral',
					value: $mailAtendimento
				},
				{
					title: 'Alugueis',
					value: $mailLocacao
				},
				{
					title: 'Vendas',
					value: $mailVendas
				},
				{
					title: 'Condomínios',
					value: $mailCondominios
				},
				{
					title: 'Ouvidoria',
					value: $mailOuvidoria
				},
			]
		},
		{
			title:     'Mensagem *',
			name:      'mensagem',
			required:  'required',
			type:      'textarea',
			rows: 4,
			defaultValue:      mensagem
		}
	];
	const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Mensagem: {mensagem}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage} buttons="" ></PageHeader>
	<div class="container">
		<div class="row"> 

			<div class="col-md-5 d-md-block text-md-right text-center">
				<h2 class="title color-primary mt-25"><b>Atendimento</b></h2>
				<p>
					<b class="color-primary">
						Geral - 
						<a class="color-primary" href="{$linkTelefone}" title="Contato via Telefone Atendimento - {$textSite}" target="_blank">
							{$textTelefone} <i class="fas fa-phone"></i>
						</a> 
					</b>
					<br>                    
					<b class="color-primary">
						Condomínios - 
						<a class="color-primary" href="{$linkWhatsappCondominio}" title="Contato via WhatsApp Condomínios - {$textSite}" target="_blank">
							{$textWhatsappCondominio} <i class="fab fa-whatsapp"></i>
						</a> 
					</b>
					<br>                    
					<b class="color-primary">
						Locações - 
						<a class="color-primary" href="{$linkWhatsappLocacao}" title="Contato via WhatsApp Locações - {$textSite}" target="_blank">
							{$textWhatsappLocacao} <i class="fab fa-whatsapp"></i>
						</a> 
					</b>
					<br>                    
					<b class="color-primary">
						Vendas/Manutenções - 
						<a class="color-primary" href="{$linkWhatsappVendas}" title="Contato via WhatsApp Vendas - {$textSite}" target="_blank">
							{$textWhatsappVendas} <i class="fab fa-whatsapp"></i>
						</a> 
					</b>
					<br>                    
					<b class="color-primary">
						Recursos Humanos - 
						<a class="color-primary" href="{$linkWhatsappRH}" title="Contato via WhatsApp RH - {$textSite}" target="_blank">
							{$textWhatsappRH} <i class="fab fa-whatsapp"></i>
						</a> 
					</b>
					<br><br>
					{@html $textAtendimento}
				</p>

				<h2 class="title color-primary mt-25"><b>Endereço</b></h2>
				<p>Endereço {@html $textEndereco}</p>		
				<ul class="list list--point-destaque">
				{#each localizacao as l}
					<li class="list-item">
						<a href="{l.link}" target="_blank" title="Endereço {$textSite} via {l.title}">
							{@html l.icon} {l.title} 
						</a>
					</li>
				{/each}
				</ul>
				<hr>
			</div>

			<div class="col-md-5 offset-md-1">       
				<Forms destiny={''} fields={fields} {message} htmlbody={false} />
				<hr>
			</div>
		</div>
	</div>
</section>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'
a
	color: $color-secondary
	&:hover
		color: $color-primary

</style>